import React from "react";
import CalloutLabel from "../utils/CalloutLabel";

class EditorToolbar extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this._position();
  }

  _position() {
    const toolbarRect = this.container.getBoundingClientRect();
    const selectionContainerRect = this.container.parentNode.parentNode.parentNode.parentNode.getBoundingClientRect();

    const offsetLeft = selectionContainerRect.left - toolbarRect.left;
    const offsetRight =
      selectionContainerRect.width +
      selectionContainerRect.left -
      (toolbarRect.width + toolbarRect.left);

    if (offsetLeft >= 0) {
      this.container.style.left = offsetLeft + 5 + "px";
    }

    if (offsetRight <= 0) {
      this.container.style.left = offsetRight - 5 + "px";
    }
  }

  componentDidUpdate() {
    this._position();
  }

  render() {
    let { position } = this.props;

    let style = {
      position: "absolute",
      bottom: position + 2,
    };

    return (
      <div
        style={style}
        ref={(container) => {
          this.container = container;
        }}
      >
        <CalloutLabel>{this.props.children}</CalloutLabel>
      </div>
    );
  }
}

export default EditorToolbar;
